import { state } from '@angular/animations';
import { AppConfigState } from '@d-store/constant';
import { createReducer, on } from '@ngrx/store';
import {
  updateCurrencyConfig,
  updateCurrentPermission,
} from './app-config.action';

export const AppConfigReducer = createReducer<AppConfigState>(
  {
    generalSetting: { currency: 'MYR', currencyPrefix: 'MYR' },
    modulePermission: null,
  },
  on(updateCurrencyConfig, (state, action) => {
    return {
      ...state,
      generalSetting: {
        ...state.generalSetting,
        currencyPrefix: action.currencyPrefix,
        currency: action.currency,
      },
    };
  }),
  on(updateCurrentPermission, (state, payload) => {
    return {
      ...state,
      modulePermission: payload.modulePermission,
    };
  }),
);
